<template>
  <div class="page">
    <navigation
      class="header"
      :theme="{
        background: '#fff',
      }"
    >账号注销
    </navigation>
    <div class="content">
      <div class="separator"></div>
      <signout-result-status :result="result"/>
      <signout-result-actions :result="result"/>
      <call-service-button
        class="call"
        @onCall="serviceDialogVisible=true"
      />
      <div class="call-tips">需要帮助，请联系客服</div>
    </div>
    <service-jw v-model="serviceDialogVisible"></service-jw>
  </div>
</template>

<script>
import signoutResultStatus from '@/view/mine/signout/components/signout-result-status'
import signoutResultActions from '@/view/mine/signout/components/signout-result-actions'
import callServiceButton from '@/components/service-button'

const StatusStrategies = {
  HAS_LOAN: {
    code: 'HAS_LOAN',
    status: 'FAILURE',
    title: '当前不可注销',
    desc: '当前尚有还款借据，需完成所有还款再进行操作'
  },
  WAIT_PAY_RIGHTS_ORDER: {
    code: 'WAIT_PAY_RIGHTS_ORDER',
    status: 'FAILURE',
    title: '当前不可注销',
    desc: '当前有未支付权益订单，需完成支付再进行操作'
  },
  HAS_BENEFIT: {
    code: 'HAS_BENEFIT',
    status: 'FAILURE',
    title: '当前不可注销',
    desc: '当前仍有生效中的权益待使用，不可注销'
  },
  HAS_GOING_STATUS: {
    code: 'HAS_GOING_STATUS',
    status: 'FAILURE',
    title: '当前不可注销',
    desc: '系统繁忙，请稍后再试'
  }
}

export default {
  name: 'signout-reason',
  components: {
    signoutResultStatus,
    signoutResultActions,
    callServiceButton,
    serviceJw: () => import('@/components/service-jw')
  },
  async created () {
    const code = this.reasonCode || 'HAS_GOING_STATUS'
    this.result = StatusStrategies[code]
    this.$bus.$emit('ready')
  },
  data () {
    return {
      serviceDialogVisible: false,
      reasonCode: this.$route.query.code,
      result: {
        code: '',
        status: '',
        title: '',
        desc: ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  width: 750px;
  height: 100%;
  background: #fff;
  .content {
    .separator {
      width: 100%;
      height: 20px;
      background: #fafafa;
    }
  }
  .call {
    position: absolute;
    bottom: 193px;
    left: 275px;
  }
  .call-tips {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 33px;
    position: absolute;
    bottom: 140px;
    left: 255px;
  }
}
</style>